import { render, staticRenderFns } from "./ElPaginationUse.vue?vue&type=template&id=9dd0e508&scoped=true"
import script from "./ElPaginationUse.vue?vue&type=script&lang=js"
export * from "./ElPaginationUse.vue?vue&type=script&lang=js"
import style0 from "./ElPaginationUse.vue?vue&type=style&index=0&id=9dd0e508&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd0e508",
  null
  
)

export default component.exports